module.exports = __webpack_public_path__ + "static/media/chat.7f51690e.svg";